export default __webpack_public_path__ + "static/media/firmware.82a5e7b5.svg";